














































































































































































































































































































































































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import RecurrenceUtils from "../../utils/recurrenceUtils";
import { Destinataire, RecurrenceRule, Abonnement } from "@/shared/Recurrence";
import ErrorMixin from "@/mixins/errorMixins";
import Vue from "vue";

@Component({
  components: {},
})
export default class DestinationAdder extends mixins(ErrorMixin) {
  @Prop() public selectedDestinataire!: Destinataire;
  @Prop({ default: false }) public filterFec!: boolean;
  @Prop() public listRules!: RecurrenceRule[];
  @Prop() public listAbo!: Abonnement[];
  public temporaryRules: RecurrenceRule[] = [];
  public selectedAbo: Abonnement = new Abonnement();
  public showListRegle = false;
  public selectedEmail = "";

  public emailRules = [
    (v: any) =>
      !v ||
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "L'email n'est pas valide.",
  ];
  public isEmailValid = false;
  public newEmail = "";

  public dialogSupprEmail = false;
  public dialogSupprDest = false;
  public dialogAddEmail = false;

  public msgErreurChampVide = this.$t("msgErreurChampVide").toString();

  public show = false;

  @Watch("selectedDestinataire.$abonnements", { immediate: true, deep: true })
  public onAbonnementsChanged() {
    this.$forceUpdate();
  }

  public selectType() {
    if (this.selectedDest.fabricClassName === "FabricDestinationFTP") {
      const host = {
        port: 22,
        dossier: "",
        host: "",
        user: "",
        password: "",
      };

      Vue.set(this.selectedDest.$decodedScript, "ftps", [host]);
    }
  }

  public async saveDest() {
    if (this.selectedDest.name === "") {
      const err =
        this.$t("Nom").toString() + " " + this.$t("required").toString();
      this.setErrorFromTxt(err);

      return;
    }

    if (this.selectedDest.fabricClassName === "") {
      alert("fabricClassName non reconnue");
      return;
    }

    if (
      this.selectedDest.fabricClassName === null ||
      this.selectedDest.fabricClassName === ""
    ) {
      this.selectedDest.fabricClassName = "FabricDestinationEmail";
    }

    this.selectedDest.script = JSON.stringify(this.selectedDest.$decodedScript);

    if (this.selectedDest.id !== "") {
      await this.updateDest();
    } else {
      Vue.set(
        this.selectedDest,
        "$abonnements",
        JSON.parse(JSON.stringify(this.temporaryRules))
      );

      await new Promise<void>((resolve) => {
        this.$emit("addDest", this.selectedDest, resolve);
      });
      for (const rule of this.temporaryRules) {
        if (rule.id) {
          this.selectedAbo = new Abonnement();
          await this.addRegle(rule.id);
        }
      }
    }
  }

  public selectRegle(id: any) {
    this.addRegle(id);
    this.showListRegle = false;
  }

  public selectTempRule(id: any) {
    const selectedRule = this.listRules.find((rule: any) => rule.id === id);
    if (selectedRule && !this.temporaryRules.some((rule) => rule.id === id)) {
      this.temporaryRules.push({ ...selectedRule });
    }

    this.showListRegle = false;
  }

  public removeTempRule(item: any) {
    this.temporaryRules = this.temporaryRules.filter(
      (tempRule) => tempRule.id !== item.id
    );
  }

  public async deleteDest() {
    this.dialogSupprDest = false;
    this.$emit("deleteDest", this.selectedDest);
  }

  public async addEmail(email: any) {
    if (this.selectedDest.$decodedScript.emails !== undefined) {
      Vue.set(
        this.selectedDest.$decodedScript.emails,
        this.selectedDest.$decodedScript.emails.length,
        email
      );
    } else {
      Vue.set(this.selectedDest.$decodedScript, "emails", [email]);
    }

    this.dialogAddEmail = false;
    this.$forceUpdate();
  }

  public ensureAbonnements(): void {
    if (!this.selectedDest.$abonnements) {
      Vue.set(this.selectedDest, "$abonnements", []);
    }
  }

  public addAboToSelectedDest(destination: any) {
    if (!this.selectedAbo || !this.selectedAbo.regleExportable) {
      return;
    }

    const newAbo = { ...this.selectedAbo.regleExportable };

    this.ensureAbonnements();

    const alreadyExists = this.selectedDest.$abonnements!.some(
      (abo) => abo.id === newAbo.id
    );

    if (alreadyExists) {
      return;
    }

    this.selectedDest.$abonnements!.push(newAbo);
    this.$forceUpdate();
  }

  public async deleteEmail(email: any) {
    this.selectedDest.$decodedScript.emails =
      this.selectedDest.$decodedScript.emails.filter(
        (mail: string) => mail !== email
      );

    this.$forceUpdate();
  }

  public unsubscribeMe(evt: any) {
    this.$emit("unsubscribe", { dest: this.selectedDest, ruleid: evt.id });
    const ruleId = evt.id;

    RecurrenceUtils.unsubscribeAbo(ruleId, this.selectedDest.id).then(
      (response: any) => {
        if (
          this.selectedDest.$abonnements &&
          this.selectedDest.$abonnements.length > 0
        ) {
          this.selectedDest.$abonnements =
            this.selectedDest.$abonnements.filter(
              (element: any) => element.id !== ruleId
            );

          this.$forceUpdate();
        }

        this.setSuccess(this.$t("supprAbo").toString());
      }
    );

    this.deleteAbo();
  }

  public async addAbo() {
    this.selectedAbo.regleDestinations.push(this.selectedDest);

    if (this.selectedAbo.regleExportable.id === "") {
      const err =
        this.$t("Recurrences").toString() +
        " " +
        this.$t("manquant").toString();
      this.setErrorFromTxt(err);
      return;
    }

    if (this.selectedAbo.regleDestinations[0].id === "") {
      this.setErrorFromTxt("Veuillez sauvegarder le destinataire");
      return;
    }

    if (this.selectedAbo.regleDestinations.length > 0) {
      await this.addOne(this.selectedAbo.regleDestinations[0]);
    }

    this.selectedAbo.regleDestinations.splice(0);
  }

  public async addRegle(event: string) {
    const regle = this.listRules.find((rule: any) => rule.id === event);

    if (!regle) {
      console.error("Règle introuvable :", event);
      return;
    }

    this.selectedAbo.regleExportable = regle;
    await this.addAbo();
  }

  public filteredRegle() {
    if (this.selectedDestinataire && this.selectedDestinataire.$abonnements) {
      const abonnementsIds = this.selectedDestinataire.$abonnements.map(
        (abonnement: any) => abonnement.id
      );
      const filteredListRules = this.listRules.filter(
        (rule: any) => !abonnementsIds.includes(rule.id)
      );

      return filteredListRules;
    } else {
      console.error("selectedDestinataire ou $abonnements est indéfini");
    }
  }

  public filteredTempRules() {
    const temporaryListIds = this.temporaryRules.map(
      (tempRule: any) => tempRule.id
    );

    const filteredListRules = this.listRules.filter(
      (rule: any) => !temporaryListIds.includes(rule.id)
    );

    return filteredListRules;
  }

  public async addOne(destination: any) {
    await RecurrenceUtils.addAbo({
      ruleAboID: this.selectedAbo.regleExportable.id,
      destAbo: destination.id,
    }).then((response: any) => {
      this.setSuccess(this.$t("aboAdded").toString());
      this.$emit("addAbo", this.selectedAbo);
      this.addAboToSelectedDest(destination);
    });
  }

  public async deleteAbo() {
    this.$emit("deleteAbo", this.selectedAbo);
  }

  private async updateDest() {
    RecurrenceUtils.updateDest(this.selectedDest).then((response: any) => {
      this.setSuccess(this.$t("updateDest").toString());
    });
  }

  get selectedDest(): Destinataire {
    return this.selectedDestinataire;
  }
}
